import React from 'react';
import Pill from './Pill';

/**
 * Pill, title and lead — the opening of nearly every section.
 *
 * From the design: the three sit in a 12px column, the title is 48px bold #222
 * at 1.3 leading, and the lead is 20px regular #666 at 28px leading. The title
 * is capped at 826px and the lead at 760px, which is what keeps the centred
 * text from running the full width of the page.
 *
 * `titleWidthClass` replaces that 826px cap for a section whose title needs a
 * wider column: the English strings run longer than the Arabic ones the design
 * was drawn around, and would otherwise take a third line.
 */
const SectionHeading = ({
    pill,
    pillIcon,
    title,
    lead,
    align = 'center',
    className = '',
    titleWidthClass = 'tw-max-w-[826px]',
}) => {
    const isCentred = align === 'center';

    return (
        <div
            className={
                `tw-flex tw-flex-col tw-gap-3 ${isCentred ? 'tw-items-center tw-text-center' : 'tw-items-start tw-text-start'} ` +
                className
            }
        >
            {pill && <Pill icon={pillIcon}>{pill}</Pill>}

            {/* `text-balance` keeps the two-line titles from dropping a single
                orphan word onto the second line. */}
            {/* Size and leading together: a responsive `text-*` carries its own
                line-height and is emitted after any plain `leading-*`, which
                would otherwise be overridden and crowd the Arabic lines. */}
            <h2 className={`${titleWidthClass} tw-text-2xl/[1.4] tw-font-bold tw-text-v2-text-strong md:tw-text-4xl/[1.35] lg:tw-text-v2-h2 tw-text-balance`}>
                {title}
            </h2>

            {lead && (
                <p className={`tw-max-w-[760px] tw-text-v2-base tw-leading-[1.75] tw-text-v2-text-muted lg:tw-text-[20px] lg:tw-leading-[28px] ${isCentred ? 'tw-mx-auto' : ''}`}>
                    {lead}
                </p>
            )}
        </div>
    );
};

export default SectionHeading;
